import { onReadValue } from 'redux-recompose';

import LocalStorageService from '~services/LocalStorageService';

export const onSetVariants = onReadValue(action => {
  LocalStorageService.setUpsellingVariants(action.payload);
  return action.payload;
});
